<template>
    <div class="modal fade" id="modalTask" tabindex="-1" aria-labelledby="modalTaskLabel">
        <div class="modal-dialog modal-lg">
            <div class="modal-content rounded-3">
                <div class="modal-header">
                    <h5 class="modal-title" id="modalTaskLabel">
                        {{ localTask.ID_TASK > 0 ? 'Modifica Task' : 'Nuova Task' }}
                    </h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Nome</label>
                                <input type="text" v-model="localTask.TITOLO" class="form-control"
                                    placeholder="Nome della task">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Categoria</label>
                                <template v-if="localTask.CONDIVISO == 1">
                                    <input class="form-control" disabled
                                        value="Le task condivise non possono avere una categoria" />
                                </template>
                                <template v-else>
                                    <div v-if="categories.length > 0">
                                        <select class="form-select" v-model="localTask.FK_ID_CATEGORIA">
                                            <option disabled value="">Seleziona categoria</option>
                                            <option v-for="cat in categories" :key="cat.ID_CATEGORIA"
                                                :value="cat.ID_CATEGORIA">
                                                {{ cat.NOME }}
                                            </option>
                                        </select>
                                    </div>
                                    <div v-else>
                                        <input class="form-control" disabled value="Nessuna categoria creata" />
                                    </div>
                                </template>

                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="mb-3">
                                <label class="form-label">Descrizione</label>
                                <textarea v-model="localTask.DESCRIZIONE" class="form-control" rows="5"
                                    placeholder="Dettagli della task"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Priorità</label>
                                <select class="form-select" v-model="localTask.PRIORITY">
                                    <option disabled value="">Seleziona priorità</option>
                                    <option value="0">Bassa</option>
                                    <option value="1">Media</option>
                                    <option value="2">Alta</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Scadenza</label>
                                <Datepicker placeholder="Data scadenza" :dim="'md'" style="width: 100%;" v-model="localTask.DATA_SCADENZA" model-type="dd/MM/yyyy" :format="'dd/MM/yyyy'" />
                            </div>

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-check mb-3 text-center">
                                <input class="form-check-input" type="checkbox" id="isTaskShared"
                                    v-model="localTask.CONDIVISO" :true-value="1" :false-value="0">
                                <label class="form-check-label" for="isTaskShared">
                                    Condividi con altri utenti
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="localTask.CONDIVISO">
                        <div class="col-md-12">
                            <label class="form-label">Assegna a utenti</label>
                            <input type="text" class="form-control mb-2" placeholder="Cerca utente..."
                                v-model="filtroUtente">
                            <div style="overflow-x: auto; max-width: 100%; white-space: nowrap;">
                                <div class="d-flex flex-nowrap" style="gap: 8px;">
                                    <div v-for="utente in utentiDisponibili" :key="utente.ID_UTENTE"
                                        @click="toggleUtente(utente.ID_UTENTE)" :class="[
                                            'd-flex align-items-center rounded-pill px-2 py-1',
                                            utentiSelezionati.includes(utente.ID_UTENTE)
                                                ? 'bg-primary text-white'
                                                : 'bg-light text-dark'
                                        ]" style="min-width: max-content; cursor: pointer; user-select: none;">
                                        <div class="me-2">
                                            <img v-if="utente.URL_AVATAR" :src="utente.URL_AVATAR" alt="avatar"
                                                style="width: 24px; height: 24px; border-radius: 50%; object-fit: cover;" />
                                            <i v-else class="fa fa-user"
                                                :class="utentiSelezionati.includes(utente.ID_UTENTE) ? 'text-white' : 'text-secondary'"
                                                style="font-size: 20px;"></i>
                                        </div>
                                        <small>{{ utente.USERNAME }}</small>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                    <button type="button" class="btn btn-primary" @click="conferma">
                        {{ localTask.ID_TASK > 0 ? 'Salva modifiche' : 'Crea task' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from '@vuepic/vue-datepicker'


export default {
    name: 'ModalToDo',
    components: {
        Datepicker,
    },
    props: {
        task: {
            type: Object,
            required: true,
        },
        categories: {
            type: Array,
            required: false,
        },
        arrayUtenti: {
            type: Array,
            required: true,
        }
    },
    data() {
        return {
            filters: global.filters,
            localTask: {},
            utentiSelezionati: new Array(),
            filtroUtente: '',
            arrayItems : new Array(),
        };
    },
    watch: {
        task: {
            immediate: true,
            handler(nuovo) {
                this.localTask = { ...nuovo, CONDIVISO: nuovo.CONDIVISO ? 1 : 0 };
                this.utentiSelezionati = (nuovo.UTENTI_ASSEGNATI || []).map(u => u.ID_UTENTE); //?
            },
        },
        'localTask.CONDIVISO'(val) {
            if (!val) this.utentiSelezionati = [];
        }
    },
    methods: {
        conferma() {
            if (!this.utentiSelezionati.includes(this.$root.utente.ID_UTENTE)) {
                this.utentiSelezionati.push(this.$root.utente.ID_UTENTE);
            }
            const taskConUtenti = {
                ...this.localTask,
                UTENTI_ASSEGNATI: this.utentiSelezionati
            };
            if ((this.arrayItems || []).length > 0) {
                const payload = {
                    task: taskConUtenti,
                    array_items: this.arrayItems
                };
                utils.ajax('todo/task/insert/multipla', payload, response => {
                    if (response.esito == 0) {
                        utils.alert.success("Task associata correttamente agli item selezionati.");
                        this.filters.closePopUp('modalTask');
                        this.arrayItems = [];
                    } else {
                        utils.alert.danger("Errore nella creazione multipla: " + response.messaggio);
                    }
                });
                this.$emit('task-multipla-creata');
                return;
            }
            this.filters.closePopUp('modalTask');
            this.$emit('salva', taskConUtenti);
        },
        createTask(modulo) {
            this.localTask = { ID_TASK: 0, CONDIVISO: 0 , FK_ID_MODULO: modulo };
            var modal = filters.openPopUp('modalTask');
        },
        createMoreTask(arraySelezionati, modulo) {
            this.localTask = { ID_TASK: 0, CONDIVISO: 0, FK_ID_MODULO: modulo };
            this.arrayItems = arraySelezionati;
            var modal = filters.openPopUp('modalTask');
        },

        editTask() {
            this.localTask = utils.clone(this.task);
            var modal = filters.openPopUp('modalTask');
        },
        toggleUtente(idUtente) {
            const index = this.utentiSelezionati.indexOf(idUtente);
            if (index == -1) {
                this.utentiSelezionati.push(idUtente);
            } else {
                this.utentiSelezionati.splice(index, 1);
            }
        },
        aggiungiPromemoria(task) {
            this.$emit('aggiungi-promemoria', task);
        },
        modificaPromemoria(task) {
            this.$emit('modifica-promemoria', task);
        }
    },
    computed: {
        utentiDisponibili() {
            const testoFiltro = this.filtroUtente.toLowerCase().trim();
            return this.arrayUtenti.filter(u =>
                u.ID_UTENTE != this.$root.utente.ID_UTENTE &&
                (!testoFiltro || u.USERNAME.toLowerCase().includes(testoFiltro))
            );
        }
    }
};
</script>